import { render, staticRenderFns } from "./sessionCategory.vue?vue&type=template&id=4bec8d6e&scoped=true"
import script from "./sessionCategory.vue?vue&type=script&lang=js"
export * from "./sessionCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bec8d6e",
  null
  
)

export default component.exports